import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { AnimatePresence } from "framer-motion";
import { checkDailyLimit } from "../utils/rateLimitUtils";
import { RateLimitModal } from "./RateLimitModal";
import "./Hero.css";

export const Hero = ({ onGenerate, isLoading }) => {
  const [name, setName] = useState("");
  const [dateOfBirth, setDateOfBirth] = useState("");
  const [profession, setProfession] = useState("Just a Human 🫠");
  const [timeframe, setTimeframe] = useState("TODAY");
  const [showRateLimitModal, setShowRateLimitModal] = useState(false);
useEffect(() => {
  const loadAd = () => {
    const container = document.getElementById("banner-ad-2");
    if (!container) return;

    const isMobile = window.innerWidth < 768;

    // clear old
    container.innerHTML = "";

    const script1 = document.createElement("script");

    if (isMobile) {
      // 📱 MOBILE → 320x50
      script1.innerHTML = `
        atOptions = {
          'key' : 'f771b4c301910b8a3e1d4985ad431959',
          'format' : 'iframe',
          'height' : 50,
          'width' : 320,
          'params' : {}
        };
      `;
    } else {
      // 💻 DESKTOP → 728x90
      script1.innerHTML = `
        atOptions = {
          'key' : 'b1b00c9c03fa7cc8892e97a40286c861',
          'format' : 'iframe',
          'height' : 90,
          'width' : 728,
          'params' : {}
        };
      `;
    }

    const script2 = document.createElement("script");
    script2.src = isMobile
      ? "https://www.highperformanceformat.com/f771b4c301910b8a3e1d4985ad431959/invoke.js"
      : "https://www.highperformanceformat.com/b1b00c9c03fa7cc8892e97a40286c861/invoke.js";

    script2.async = true;

    container.appendChild(script1);
    container.appendChild(script2);
  };

  // small delay fixes mobile rendering
  setTimeout(loadAd, 300);

}, []);
  useEffect(() => {
  const script = document.createElement("script");
  script.src = "https://pl29288993.profitablecpmratenetwork.com/d90fa235309fc59f02100e70aa38b795/invoke.js";
  script.async = true;
  script.setAttribute("data-cfasync", "false");

  document.body.appendChild(script);

  return () => {
    document.body.removeChild(script);
  };
}, []);

  const professions = [
    "Just a Human 🫠",
    "Student 📚",
    "Software Engineer 💻",
    "Content Creator 🎥",
    "Freelancer 💸",
    "Business Owner 🏢",
    "Doctor/Healthcare 🏥",
    "Teacher 👩‍🏫",
    "Artist/Designer 🎨",
    "Marketing/Sales 📊",
    "Unemployed (It's complicated) 😅",
    "Other 🤷",
  ];

  const handleGenerate = () => {
    if (!name.trim()) {
      alert("What's your name, bestie? 👀");
      return;
    }
    if (!dateOfBirth) {
      alert("Please enter your date of birth! 🌟");
      return;
    }

    // Check daily limit
    if (!checkDailyLimit()) {
      setShowRateLimitModal(true);
      return;
    }

    onGenerate(dateOfBirth, timeframe, name, profession);
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleGenerate();
    }
  };

  const handleNameChange = (e) => {
    const value = e.target.value;
    // Auto-capitalize first letter
    if (value.length === 1) {
      setName(value.toUpperCase());
    } else {
      setName(value);
    }
  };

  const getMaxDate = () => {
    const today = new Date();
    const maxDate = new Date(today.getFullYear() - 13, today.getMonth(), today.getDate());
    return maxDate.toISOString().split('T')[0];
  };

  const getMinDate = () => {
    const minDate = new Date(1920, 0, 1);
    return minDate.toISOString().split('T')[0];
  };
  
  const getTodayDate = () => {
    return new Date().toISOString().split('T')[0];
  };

  return (
    <>
      <section className="hero" id="home">
      <motion.div
        className="hero-content"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >

        <div id="container-d90fa235309fc59f02100e70aa38b795" className="ad-placeholder">
         
         </div>

         
        <motion.h1
          className="hero-title"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.1 }}
        >
          Your Horoscope.
          <br />
          But Make It Honest 🔥
        </motion.h1>

        <motion.p
          className="hero-subtitle"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          No sugarcoating. Just cosmic truth.
        </motion.p>

        {/* Input Container */}
        <motion.div
          className="input-container"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.3 }}
        >
          {/* Name Input */}
          <input
            type="text"
            value={name}
            onChange={handleNameChange}
            onKeyPress={handleKeyPress}
            placeholder="What's your name, bestie? 👀"
            className="name-input"
            disabled={isLoading}
            aria-label="Your name"
            maxLength="50"
          />

          {/* Date Input Label */}
          <label htmlFor="dob-input" className="date-input-label">Date of Birth 🎂</label>
          
          {/* Date Input */}
          <input
            id="dob-input"
            type="date"
            value={dateOfBirth}
            onChange={(e) => setDateOfBirth(e.target.value)}
            onKeyPress={handleKeyPress}
            max={getTodayDate()}
            min={getMinDate()}
            className="date-input"
            disabled={isLoading}
            aria-label="Date of birth"
          />

          {/* Profession Dropdown */}
          <select
            value={profession}
            onChange={(e) => setProfession(e.target.value)}
            className="profession-select"
            disabled={isLoading}
            aria-label="Your profession"
          >
            {professions.map((prof) => (
              <option key={prof} value={prof}>
                {prof}
              </option>
            ))}
          </select>

          {/* Timeframe Toggles */}
          <div className="timeframe-toggles">
            {["TODAY", "THIS MONTH", "THIS YEAR"].map((frame) => (
              <button
                key={frame}
                className={`toggle-btn ${timeframe === frame ? "active" : ""}`}
                onClick={() => setTimeframe(frame)}
                disabled={isLoading}
                aria-label={`Select ${frame}`}
              >
                {frame}
              </button>
            ))}
          </div>
        </motion.div>

        {/* Generate Button */}
        <motion.button
          className="generate-btn"
          onClick={handleGenerate}
          disabled={isLoading}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
        >
          {isLoading ? (
            <>
              <span className="spinner"></span>
              <span>The stars are aligning...</span>
            </>
          ) : (
            "WTF IS MY HOROSCOPE"
          )}
        </motion.button>
      </motion.div>

      {/* Ad Slot Below Hero */}
      <div id="banner-ad-2" className="ad-placeholder">
        Advertisement Space
      </div>
      </section>

      {/* Rate Limit Modal */}
      <AnimatePresence>
        {showRateLimitModal && (
          <RateLimitModal onClose={() => setShowRateLimitModal(false)} />
        )}
      </AnimatePresence>
    </>
  );
};
